import { SystemOptionType } from '../enum';
import { ArticleSystemOption, CategorySystemOption, SectionSystemOption } from '../types';

export function isCategoryOption (option: any): option is CategorySystemOption {
  return option?.kind === SystemOptionType.CATEGORY;
}

export function isSectionOption (option: any): option is SectionSystemOption {
  return option?.kind === SystemOptionType.SECTION;
}

export function isArticleOption (option: any): option is ArticleSystemOption {
  return option?.kind === SystemOptionType.ARTICLE;
}
